
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.518.123c-.842-.44-1.782.408-2.333.911-1.263 1.195-2.332 2.578-3.53 3.835-1.33 1.384-2.56 2.767-3.921 4.119-.778.754-1.62 1.571-2.138 2.514-1.167-1.1-2.17-2.294-3.467-3.269C2.19 7.542.635 7.04.667 8.705c.065 2.169 2.041 4.495 3.499 5.973.615.628 1.425 1.288 2.365 1.32 1.134.063 2.3-1.258 2.98-1.98 1.2-1.258 2.171-2.673 3.273-3.962 1.425-1.697 2.883-3.363 4.276-5.092.875-1.07 3.629-3.71 1.458-4.841z","fill":"#56CB4E"}})])
          )
        }
      }
    